let resource = new LostReasonsResource()

const state = {
  lost_reason_list: [],
  lost_reason_loading: false,
  lost_reason_fetched: false
}

const getters = {
  lostReasonsCount: function (state) {
    return state.lost_reason_list.length
  },
  lostReasonsList: function (state) {
    return state.lost_reason_list
  },
  lostReasonLoading: function (state) {
    return state.lost_reason_loading
  },
  lostReasonFetched: function (state) {
    return state.lost_reason_fetched
  }
}

const mutations = {
  loadLostReasons: function (state, lost_reasons) {
    if (lost_reasons) {
      state.lost_reason_list = lost_reasons
    } else {
      state.lost_reason_list = []
    }
  },
  addLostReason: function (state, lost_reason) {
    state.lost_reason_list.unshift(lost_reason)
  },
  removeLostReason: function (state, lost_reason) {
    state.lost_reason_list.remove(lost_reason.id)
  },
  replaceLostReason: function (state, lost_reason) {
    state.lost_reason_list.replaceById(lost_reason)
  },
  resetLostReasons: function (state) {
    state.lost_reason_list = []
  },
  setLostReasonLoading: function (state, loading) {
    state.lost_reason_loading = loading
  },
  setLostReasonFetched: function (state, fetched) {
    state.lost_reason_fetched = fetched
  },
  lostReasonsCount: function (state, value) {
    state.lost_reason_list.length = value
  },
  lostReasonsList: function (state, value) {
    state.lost_reason_list = value
  },
  lostReasonLoading: function (state, value) {
    state.lost_reason_loading = value
  },
  lostReasonFetched: function (state, value) {
    state.lost_reason_fetched = value
  }
}

const actions = {
  fetchLostReasons (context, payload){
    context.commit('setLostReasonLoading', true)

    if(!context.getters.lostReasonFetched) {
      resource.index(response => {
        context.commit('setLostReasonLoading', false)
        context.commit('setLostReasonFetched', true)
        context.commit('loadLostReasons', response.lost_reasons)
      },

      function(error) {
        context.commit('setLostReasonLoading', false)
        if(payload && payload.errorCallback) {
          payload.errorCallback(error)
        }
      })
    }
    context.commit('setLostReasonLoading', false)
  },

  resetLostReasons (context) {
    context.commit('lostReasonFetched', false)
    context.commit('lostReasonLoading', false)
    context.commit('lostReasonsList', [])
  },

  createLostReason (context, payload) {
    context.commit('setLostReasonLoading', true)

    resource.create(response => {
      context.commit('setLostReasonLoading', false)
      context.commit('addLostReason', response.data.lost_reason)

      alertify.success('Motivo de perda salvo com sucesso.')
    },

    function(error) {
      context.commit('setLostReasonLoading', false)
      alertify.error('Ocorreu um erro ao salvar o motivo de perda.')
    }, payload)
  },

  removeLostReason (context, payload) {
    context.commit('setLostReasonLoading', true)

    resource.destroy(response => {
      console.log(response)
      context.commit('setLostReasonLoading', false)
      context.commit('removeLostReason', payload)

      alertify.success('Motivo de perda excluído com sucesso.')
    },

    function(error) {
      context.commit('setLostReasonLoading', false)
      if(!error.body || !error.body.base) {
        alertify.error('Ocorreu um erro ao excluir o motivo de perda.')
        return
      }

      alertify.error(error.body.base[0])
    }, payload)
  },

  updateLostReason (context, payload) {
    context.commit('setLostReasonLoading', true)

    resource.update(response => {
      context.commit('setLostReasonLoading', false)
      context.commit('replaceLostReason', response.lost_reason)

      alertify.success('Motivo de perda salvo com sucesso.')
    },

    function(error) {
      context.commit('setLostReasonLoading', false)
      alertify.error('Ocorreu um erro ao salvar o motivo de perda.')
    }, payload)
  },
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/lost_reason.js